export interface SelectProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "onChange"> {
  label: string;
  placeholder?: string;
  options: { value: string; label: string }[];
  onChange?: (value: string) => void;
  errorText?: string;
}

export const Select = ({
  name,
  label,
  placeholder,
  onChange,
  required,
  errorText,
  ...restProps
}: SelectProps) => {
  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  return (
    <div>
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-semibold text-gray-900 dark:text-white"
      >
        {label} {required ? <span className="text-red-500">*</span> : ""}
      </label>

      <select
        id={name}
        className={`bg-border border text-gray-900 text-sm rounded-md block w-full p-2 outline-none focus:ring-0 focus:ring-offset-0 focus:ring-border focus:border-gray-300 ${
          errorText ? "border-red-500" : "border-gray-300"
        }`}
        onChange={handleOnChange}
        {...restProps}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {restProps.options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errorText && <p className="text-xs text-red-500 mt-1">{errorText}</p>}
    </div>
  );
};
